import React, { useState, useEffect } from "react";
import axios from 'axios';
import Modal from "react-bootstrap/Modal";

//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input, Textarea } from "../../../../ui/inputs/Input";
import { Mensaje } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';

export default function Bancos({ show, setShow, operacion, id, onRecargar }) {
  var op = require('../../../../modulos/datos');
  let token = localStorage.getItem('jwtToken');

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

  // Estado del formulario
  const [formData, setFormData] = useState({
    ccodban: '',      // Código del banco
    cnomban: '',      // Nombre del banco
    csucursal: '',    // Sucursal
    numcuent: '',     // Número de cuenta
    cgerente: '',     // Gerente
    cdirban: ''       // Dirección del banco
  });

  // Obtener el código de nómina actual para el esquema
  const getEsquema = () => {
    let codigoNomina = localStorage.getItem('codigonomina');
    return codigoNomina ? `nomi${codigoNomina.replace(/"/g, '')}` : '';
  };

  // Función para validar solo números
  const soloNumeros = (value) => {
    return value.replace(/[^0-9]/g, '');
  };

  // Función para validar solo letras y espacios
  const soloLetrasYEspacios = (value) => {
    return value.replace(/[^a-zA-ZáéíóúñÑ\s]/g, '');
  };

  // Cargar datos si es edición o consulta
  useEffect(() => {
    if (show && (operacion === 2 || operacion === 3 || operacion === 4) && id) {
      cargarBanco(id);
    } else if (show && operacion === 1) {
      // Limpiar formulario para nuevo registro
      setFormData({
        ccodban: '',
        cnomban: '',
        csucursal: '',
        numcuent: '',
        cgerente: '',
        cdirban: ''
      });
    }
  }, [show, operacion, id]);

  const cargarBanco = (codigoBanco) => {
    let esquema = getEsquema();
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=${esquema}.banco&condi=codban='${codigoBanco}'&orden=codban`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
      }
    })
      .then(function (response) {
        if (response.status === 200 && response.data.length > 0) {
          const banco = response.data[0];
          setFormData({
            ccodban: banco.codban ? banco.codban.trim() : '',
            cnomban: banco.nomban ? banco.nomban.trim() : '',
            csucursal: banco.sucursal ? banco.sucursal.trim() : '',
            numcuent: banco.nrocue ? banco.nrocue.trim() : '',
            cgerente: banco.gerente ? banco.gerente.trim() : '',
            cdirban: banco.dirban ? banco.dirban.trim() : ''
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || error.message,
          icono: 'error'
        });
        setActivate(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let nuevoValor = value;
    
    // Aplicar validaciones según el campo
    if (name === 'numcuent') {
      // Solo números para el número de cuenta
      nuevoValor = soloNumeros(value);
    } else if (name === 'ccodban') {
      // Solo números para el código del banco
      nuevoValor = soloNumeros(value);
    } else if (name === 'cnomban' || name === 'csucursal' || name === 'cgerente') {
      // Solo letras y espacios para nombres
      nuevoValor = soloLetrasYEspacios(value);
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: nuevoValor
    }));
  };

  // Función para manejar el evento keyPress (evita que se escriban letras)
  const handleKeyPress = (e, fieldName) => {
    if (fieldName === 'numcuent' || fieldName === 'ccodban') {
      const key = e.key;
      // Permitir solo números, teclas de control y teclas especiales
      const soloNumeros = /^[0-9]$/;
      const teclasPermitidas = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
      
      if (!soloNumeros.test(key) && !teclasPermitidas.includes(key)) {
        e.preventDefault();
      }
    }
  };

  const validarCampos = () => {
    // Aplicar trim a los valores antes de validar
    const ccodbanTrim = formData.ccodban.trim();
    const cnombanTrim = formData.cnomban.trim();
    const csucursalTrim = formData.csucursal.trim();
    const numcuentTrim = formData.numcuent.trim();
    const cgerenteTrim = formData.cgerente.trim();
    const cdirbanTrim = formData.cdirban.trim();

    if (!ccodbanTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El código del banco es requerido', icono: 'informacion' });
      return false;
    }
    // Validar que el código del banco sea numérico
    if (!/^\d+$/.test(ccodbanTrim)) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El código del banco debe contener solo números', icono: 'informacion' });
      return false;
    }
    if (!cnombanTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El nombre del banco es requerido', icono: 'informacion' });
      return false;
    }
    if (!csucursalTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'La sucursal es requerida', icono: 'informacion' });
      return false;
    }
    if (!numcuentTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El número de cuenta es requerido', icono: 'informacion' });
      return false;
    }
    // Validar que el número de cuenta solo contenga números
    if (!/^\d+$/.test(numcuentTrim)) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El número de cuenta debe contener solo números', icono: 'informacion' });
      return false;
    }
    if (!cgerenteTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'El nombre del gerente es requerido', icono: 'informacion' });
      return false;
    }
    if (!cdirbanTrim) {
      setMensaje({ mostrar: true, titulo: 'Validación', texto: 'La dirección del banco es requerida', icono: 'informacion' });
      return false;
    }
    return true;
  };

  const guardarBanco = () => {
    if (!validarCampos()) return;

    // Para consulta (operacion=4), solo mostrar datos, no guardar
    if (operacion === 4) {
      setMensaje({ mostrar: true, titulo: 'Información', texto: 'Modo consulta - Solo visualización', icono: 'info' });
      return;
    }

    // Para eliminación, confirmar
    if (operacion === 3) {
      if (!window.confirm('¿Está seguro de eliminar este banco?')) {
        return;
      }
    }

    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina.replace(/"/g, '');

    // Preparar el body con los campos solicitados
    const body = {
      operacion: operacion,           // 1=Incluir, 2=Editar, 3=Eliminar, 4=Consultar
      ccodban: formData.ccodban.trim(),
      cnomban: formData.cnomban.trim().toUpperCase(),
      csucursal: formData.csucursal.trim().toUpperCase(),
      cgerente: formData.cgerente.trim().toUpperCase(),
      cdirban: formData.cdirban.trim().toUpperCase(),
      numcuent: formData.numcuent.trim(),
      esquema1: `nomi${codigoNomina}`
    };

    console.log('Body enviado al backend:', body); // Para depuración

    const endpoint = `${op.conexion}/api/nomina/banco_act`;

    setActivate(true);
    axios.post(endpoint, body, {
      headers: {
        "x-access-token": `${token}`,
        'Content-Type': 'application/json'
      }
    })
      .then(function (response) {
        if (response.status === 200) {
          let mensajeExito = '';
          switch (operacion) {
            case 1: mensajeExito = 'Banco creado exitosamente'; break;
            case 2: mensajeExito = 'Banco actualizado exitosamente'; break;
            case 3: mensajeExito = 'Banco eliminado exitosamente'; break;
            default: mensajeExito = 'Operación completada exitosamente';
          }
          setMensaje({ mostrar: true, titulo: 'Éxito', texto: mensajeExito, icono: 'exito' });

          // Recargar tabla y cerrar modal después de 2 segundos
          onRecargar();
          salir();

        }
        setActivate(false);
      })
      .catch(function (error) {
        console.error('Error al guardar:', error);
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || error.message,
          icono: 'error'
        });
        setActivate(false);
      });
  };

  const salir = () => {
    setShow(false);
  };

  const cancelar = () => {
    salir();
  };

  // Función para limpiar espacios al perder el foco
  const handleBlur = (fieldName) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: prev[fieldName].trim()
    }));
  };

  // Determinar si los campos están deshabilitados (modo consulta)
  const isDisabled = operacion === 4;
  const isEliminar = operacion === 3;

  return (
    <>
      <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
        <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
          <h3 className="fw-bold m-0">
            {operacion === 1 && 'Incluir Banco'}
            {operacion === 2 && 'Editar Banco'}
            {operacion === 3 && 'Eliminar Banco'}
            {operacion === 4 && 'Consultar Banco'}
          </h3>
          <a type="button" className="fw-bold text-light fs-6" onClick={salir} style={{ cursor: 'pointer' }}>
            Salir <i className="fa fa-times ms-2"></i>
          </a>
        </Modal.Header>
        <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
          <div className="col-3 m-0 mb-2 p-0">
            <Input
              label="Código del Banco:"
              name="ccodban"
              value={formData.ccodban}
              onChange={handleChange}
              onKeyPress={(e) => handleKeyPress(e, 'ccodban')}
              onBlur={() => handleBlur('ccodban')}
              disabled={isDisabled}
              maxLength={2}
              required
            />
          </div>
          <div className="col-9 m-0 mb-2 p-0 pl-2">
            <Input
              label="Nombre del Banco:"
              name="cnomban"
              value={formData.cnomban}
              onChange={handleChange}
              onBlur={() => handleBlur('cnomban')}
              disabled={isDisabled || isEliminar}
              required
            />
          </div>
          <div className="col-6 m-0 mb-2 p-0">
            <Input
              label="Sucursal:"
              name="csucursal"
              value={formData.csucursal}
              onChange={handleChange}
              onBlur={() => handleBlur('csucursal')}
              disabled={isDisabled || isEliminar}
              required
            />
          </div>
          <div className="col-6 m-0 mb-2 p-0 pl-2">
            <Input
              label="Nro de Cuenta:"
              name="numcuent"
              value={formData.numcuent}
              onChange={handleChange}
              onKeyPress={(e) => handleKeyPress(e, 'numcuent')}
              onBlur={() => handleBlur('numcuent')}
              disabled={isDisabled || isEliminar}
              placeholder="Solo números"
              required
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Input
              label="Nombre del Gerente:"
              name="cgerente"
              value={formData.cgerente}
              onChange={handleChange}
              onBlur={() => handleBlur('cgerente')}
              disabled={isDisabled || isEliminar}
              required
            />
          </div>
          <div className="col-12 m-0 p-0">
            <Textarea
              label="Dirección del Banco:"
              name="cdirban"
              value={formData.cdirban}
              onChange={handleChange}
              onBlur={() => handleBlur('cdirban')}
              disabled={isDisabled || isEliminar}
              style={{ height: 70 }}
              required
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {operacion !== 4 && !isEliminar && (
            <SuccessButton onClick={guardarBanco}>
              Aceptar
            </SuccessButton>
          )}
          {operacion === 3 && (
            <SuccessButton onClick={guardarBanco}>
              Eliminar
            </SuccessButton>
          )}
          <DangerButton onClick={cancelar}>
            Cancelar
          </DangerButton>
        </Modal.Footer>
      </Modal>

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })}
      />
    </>
  );
}